// ข้อมูลผู้ใช้งานระบบ

import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of, Subject } from "rxjs";
import { debounceTime, delay, switchMap, tap } from "rxjs/operators";
import { SortDirection } from "../../@theme/directives/sort.directive";
import {State } from "../data/complete";


export interface Mock {
    id: number;
    cus_id: string;
    firstname: string;
    username: string;
    branch: string;
    permisstion: string;
    status: string;
    create_datetime: string;
    emp_edit: string;
    update_datetime: string
  }
  const MOCKS :Mock[] = [
    {
      id: 1,
      cus_id: "E210097",
      firstname: "สมยศ สดสวย",
      username: "somy29",
      branch: "รัตนาธิเบศ",
      permisstion: "พนักงานขาย",
      status: "ใช้งาน",
      create_datetime: "20/07/2021 09:00",
      emp_edit: "อัจฉรา สดใส",
      update_datetime: "22/07/2021 21:00",
    },
    {
      id: 2,
      cus_id: "E210096",
      firstname: "จิระ ภาควัฒ",
      username: "jira",
      branch: "เกษตรนวมินทร์",
      permisstion: "จัดการรถ",
      status: "ยกเลิก",
      create_datetime: "12/07/2021 09:00",
      emp_edit: "อัจฉรา สดใส",
      update_datetime: "15/07/2021 21:00",
    },
    {
      id: 3,
      cus_id: "E210095",
      firstname: "สมใจ แจ่งใส",
      username: "somyjai",
      branch: "กลางดง",
      permisstion: "หัวหน้าพนักงานขาย",
      status: "ยกเลิก",
      create_datetime: "09/07/2021 09:00",
      emp_edit: "อัจฉรา สดใส",
      update_datetime: "11/07/2021 21:00",
    },
    {
      id: 4,
      cus_id: "E210094",
      firstname: "สุขจิต รังสรรค์",
      username: "sookjit",
      branch: "เกษตรนวมินทร์",
      permisstion: "หัวหน้าจัดการรถ",
      status: "ยกเลิก",
      create_datetime: "09/07/2021 09:00",
      emp_edit: "อัจฉรา สดใส",
      update_datetime: "11/07/2021 21:00",
    },
    {
      id: 5,
      cus_id: "E210093",
      firstname: "ศิระ จึงดี",
      username: "sk118",
      branch: "กลางดง",
      permisstion: "จัดการรถ",
      status: "ยกเลิก",
      create_datetime: "09/07/2021 09:00",
      emp_edit: "อัจฉรา สดใส",
      update_datetime: "11/07/2021 21:00",
    },
    {
      id: 6,
      cus_id: "E210097",
      firstname: "สมยศ สดสวย",
      username: "somy29",
      branch: "รัตนาธิเบศ",
      permisstion: "พนักงานขาย",
      status: "ใช้งาน",
      create_datetime: "20/07/2021 09:00",
      emp_edit: "อัจฉรา สดใส",
      update_datetime: "22/07/2021 21:00",
    },
    {
      id: 7,
      cus_id: "E210096",
      firstname: "จิระ ภาควัฒ",
      username: "jira",
      branch: "เกษตรนวมินทร์",
      permisstion: "จัดการรถ",
      status: "ยกเลิก",
      create_datetime: "12/07/2021 09:00",
      emp_edit: "อัจฉรา สดใส",
      update_datetime: "15/07/2021 21:00",
    },
    {
      id: 8,
      cus_id: "E210095",
      firstname: "สมใจ แจ่งใส",
      username: "somyjai",
      branch: "กลางดง",
      permisstion: "หัวหน้าพนักงานขาย",
      status: "ยกเลิก",
      create_datetime: "09/07/2021 09:00",
      emp_edit: "อัจฉรา สดใส",
      update_datetime: "11/07/2021 21:00",
    },
    {
      id: 9,
      cus_id: "E210094",
      firstname: "สุขจิต รังสรรค์",
      username: "sookjit",
      branch: "เกษตรนวมินทร์",
      permisstion: "หัวหน้าจัดการรถ",
      status: "ยกเลิก",
      create_datetime: "09/07/2021 09:00",
      emp_edit: "อัจฉรา สดใส",
      update_datetime: "11/07/2021 21:00",
    },
    {
      id: 10,
      cus_id: "E210093",
      firstname: "ศิระ จึงดี",
      username: "sk118",
      branch: "กลางดง",
      permisstion: "จัดการรถ",
      status: "ยกเลิก",
      create_datetime: "09/07/2021 09:00",
      emp_edit: "อัจฉรา สดใส",
      update_datetime: "11/07/2021 21:00",
    },
    {
      id: 11,
      cus_id: "E210097",
      firstname: "สมยศ สดสวย",
      username: "somy29",
      branch: "รัตนาธิเบศ",
      permisstion: "พนักงานขาย",
      status: "ใช้งาน",
      create_datetime: "20/07/2021 09:00",
      emp_edit: "อัจฉรา สดใส",
      update_datetime: "22/07/2021 21:00",
    },
    {
      id: 12,
      cus_id: "E210096",
      firstname: "จิระ ภาควัฒ",
      username: "jira",
      branch: "เกษตรนวมินทร์",
      permisstion: "จัดการรถ",
      status: "ยกเลิก",
      create_datetime: "12/07/2021 09:00",
      emp_edit: "อัจฉรา สดใส",
      update_datetime: "15/07/2021 21:00",
    },
    {
      id: 13,
      cus_id: "E210095",
      firstname: "สมใจ แจ่งใส",
      username: "somyjai",
      branch: "กลางดง",
      permisstion: "หัวหน้าพนักงานขาย",
      status: "ยกเลิก",
      create_datetime: "09/07/2021 09:00",
      emp_edit: "อัจฉรา สดใส",
      update_datetime: "11/07/2021 21:00",
    },
    {
      id: 14,
      cus_id: "E210094",
      firstname: "สุขจิต รังสรรค์",
      username: "sookjit",
      branch: "เกษตรนวมินทร์",
      permisstion: "หัวหน้าจัดการรถ",
      status: "ยกเลิก",
      create_datetime: "09/07/2021 09:00",
      emp_edit: "อัจฉรา สดใส",
      update_datetime: "11/07/2021 21:00",
    },
    {
      id: 15,
      cus_id: "E210093",
      firstname: "ศิระ จึงดี",
      username: "sk118",
      branch: "กลางดง",
      permisstion: "จัดการรถ",
      status: "ยกเลิก",
      create_datetime: "09/07/2021 09:00",
      emp_edit: "อัจฉรา สดใส",
      update_datetime: "11/07/2021 21:00",
    }
  ]
  interface SearchResult {
    data: Mock[];
    total: number;
  }
const compare = (v1: string | number, v2: string | number) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

function sort(data: Mock[], column: any, direction: string): Mock[]{
  if (direction === '' || column === '') {
    return data;
  } else {
    return [...data].sort((a, b) => {
      const res = compare(a[column], b[column]);
      return direction === 'asc' ? res : -res;
    });
  }
}

@Injectable()
export class AService {
  private _loading$ = new BehaviorSubject<boolean>(true);
  private _search$ = new Subject<void>();
  private _data$ = new BehaviorSubject<Mock[]>([]);
  private _total$ = new BehaviorSubject<number>(0);
  private _state: State = {
    page: 1,
    pageSize: 5,
    sortColumn: "",
    sortDirection: "",
  };
  constructor() {
    // console.log('called check', this._search$);
    
    this._search$.pipe(
        tap(() => this._loading$.next(true)),
        debounceTime(200),
        switchMap(() => this._search()),
        delay(200),
        tap(() => this._loading$.next(false))
      ).subscribe(result => {
        this._data$.next(result.data);
        this._total$.next(result.total);
      });
  
      this._search$.next();
      
  }
  get data$() { return this._data$.asObservable(); }
  get total$() { return this._total$.asObservable(); }
  get loading$() { return this._loading$.asObservable(); }
  get page() { return this._state.page; }
  get pageSize() { return this._state.pageSize; }

  set page(page: number) { this._set({page}); }
  set pageSize(pageSize: number) { this._set({pageSize}); }
  set sortColumn(sortColumn) { this._set({sortColumn}); }
  set sortDirection(sortDirection: SortDirection) { this._set({sortDirection}); }

  private _set(patch: Partial<State>) {
    Object.assign(this._state, patch);
    this._search$.next();
  }

  private _search(): Observable<SearchResult> {
    const {sortColumn, sortDirection, pageSize, page} = this._state;

    // 1. sort
    let data = sort(MOCKS, sortColumn, sortDirection);

    const total = data.length;

    // 3. paginate
    data = data.slice((page - 1) * pageSize, (page - 1) * pageSize + pageSize);
    return of({data, total});
  }
}
